/**
 * normalizeString
 * @param {{ 
    data: string;
    actions: Array<'spacing' | 'capitalize' | 'punctuate' | 'space-capitals' | 'lowercase' | 'new-line' | 'nobreak' | 'phone' | 'capitalize-each-first-word'> 
  }} options
 */
const normalizeString = ({ data, actions }) => {
  if (data === undefined || data === null) {
    return "";
  }
  let ret = String(data);
  if (actions.includes("spacing")) {
    ret = ret
      .split(" ")
      .filter((s) => Boolean(s))
      .join(" ");
  }
  if (actions.includes("capitalize")) {
    ret = ret.charAt(0).toUpperCase() + ret.slice(1);
  }
  if (actions.includes("punctuate")) {
    ret = ret + ".";
  }
  if (actions.includes("space-capitals")) {
    let tmp = "";
    ret.split("").forEach((c, index) => {
      if (c.toUpperCase() === c && index !== 0) {
        tmp += " " + c;
      } else {
        tmp += c;
      }
    });

    ret = tmp;
  }
  if (actions.includes("lowercase")) {
    ret = ret.toLowerCase();
  }
  if (actions.includes("new-line")) {
    ret = String.fromCharCode(10) + ret;
  }
  if (actions.includes("nobreak")) {
    ret = ret.split(" ").join(String.fromCharCode(160));
  }
  if (actions.includes("phone")) {
    const sub1 = ret.substring(0, 3);
    const sub2 = ret.substring(3, 6);
    const sub3 = ret.substring(6);
    ret = `(${sub1}) ${sub2}-${sub3}`;
  }
  if (actions.includes("capitalize-each-first-word")) {
    ret = ret.split(" ");
    ret = ret.reduce((acc, word) => {
      let item = word.toLowerCase();
      item = item[0].toUpperCase() + item.slice(1);
      acc += item + " ";
      return acc;
    }, "");
  }
  return ret;
};

export default normalizeString;
